
import { Component, Vue } from 'vue-property-decorator';
import DeleteAccount from '~/components/User/UserButtons/DeleteAccount.vue';
import DeleteEmptyHomes from '~/components/User/UserButtons/DeleteEmptyHomes.vue';
import DeleteIdentityKeys from '~/components/User/UserButtons/DeleteIdentityKeys.vue';
import { ConfigModule } from '~/store/modules/config';
import { UserModule } from '~/store/modules/user';
import { UserLogsModule } from '~/store/modules/userLogs';
import { PopupModule } from '~common-store/modules/popup';

@Component({
    components: {
        DeleteAccount,
        DeleteIdentityKeys,
        DeleteEmptyHomes,
    },
})
export default class UserButtons extends Vue {
    get getUserTopologyScope() {
        return UserModule.getUserTopologyScope;
    }

    async showUserLogPopup(): Promise<void> {
        try {
            await UserLogsModule.getUserLogs();
            PopupModule.setPopupRequested('user-logs');
        } catch (error) {
            return;
        }
    }

    async showUserOrdersPopup(): Promise<void> {
        try {
            await UserModule.getUserOrders();
            if (UserModule.orders.length < 1) {
                return;
            }
            PopupModule.setPopupRequested('user-orders');
        } catch (error) {
            return;
        }
    }


    get userIsNetatmo() {
        return ['netatmo', 'legrand'].includes(ConfigModule.environmentPrefix) && UserModule.prefix === '' && UserModule.env !== 'eliot';
    }

}
